const AirConditioner = ({ className = '', style = {}, width = 7 }) => {
  return (
    <svg
      title="AirConditioner"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      width={width}
    >
      <path fill="#6F6F6F" d="M6.5 13.667v-3.25L4.017 12.9l-.717-.7L6.5 9V7.5H5l-3.133 3.133-.734-.683 2.45-2.45H.333v-1h3.25L1.083 4l.717-.717L5 6.5h1.5V4.983L3.367 1.85l.7-.733L6.5 3.567V.333h1v3.234l2.5-2.5.7.716-3.2 3.2V6.5h1.517l3.15-3.15.716.7-2.45 2.45h3.234v1h-3.234L12.9 9.983l-.683.717-3.2-3.2H7.5V9l3.2 3.217-.683.716L7.5 10.417v3.25h-1Z" />

    </svg>
  )
}

const Blackboard = ({ className = '', style = {}, width = 7 }) => {
  return (
    <svg
      title="Blackboard"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      width={width}
    >
      <path fill="#6F6F6F" d="M1 12a1 1 0 0 1-.7-.3A1 1 0 0 1 0 11V1C0 .7.1.5.3.3.5.1.7 0 1 0h10c.3 0 .5.1.7.3.2.2.3.4.3.7v10c0 .3-.1.5-.3.7a1 1 0 0 1-.7.3H1Zm0-1h10V1H1v10Zm1-1h4.2V6.7H2V10Zm4.7-5.6H10V2H6.7v2.4ZM2 6.2h4.2V2H2v4.2ZM6.7 10H10V4.9H6.7V10Z" />
    </svg>
  )
}

const Plug = ({ className = '', style = {}, width = 7 }) => {
  return (
    <svg
      title="Plug"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      width={width}
    >
      <path fill="#6F6F6F" d="M10 8V7h1.5a.5.5 0 0 1 .5.5l-.1.3-.4.2H9.9Zm0 2.7v-1h1.5a.5.5 0 0 1 .5.5l-.1.3-.4.2H9.9Zm-2.7.6a1 1 0 0 1-.8-.4c-.2-.2-.3-.5-.3-.9H4.6V7.7h1.6c0-.4 0-.7.3-1 .2-.2.5-.4.8-.4h2.1v5h-2Zm-4.7-2c-.8 0-1.4-.2-1.9-.7-.5-.5-.7-1-.7-1.9a2.5 2.5 0 0 1 2.6-2.5h1c.4 0 .7-.2 1-.4.2-.2.3-.5.3-.9s-.1-.7-.3-.9c-.3-.2-.6-.3-1-.3H1.3c-.2 0-.3 0-.4-.2a.5.5 0 0 1-.1-.3V.8l.4-.1h2.5a2.2 2.2 0 0 1 2.2 2.2 2.2 2.2 0 0 1-2.2 2.3H2.6c-.5 0-.9.1-1.2.4-.3.3-.4.7-.4 1.1 0 .5.1 1 .4 1.2.3.3.7.4 1.2.4H4v1H2.6Z" />
    </svg>
  )
}

const Projector = ({ className = '', style = {}, width = 7 }) => {
  return (
    <svg
      title="Projector"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 11"
      width={width}
    >
      <path fill="#6F6F6F" d="M11.45 3.8a1.03 1.03 0 0 0-1.05.1l-.91.64a2.46 2.46 0 0 0-2.5-2.15h-.03L4.9.42A1.52 1.52 0 0 0 3.84 0H.5C.22 0 0 .21 0 .48c0 .26.22.48.5.48h3.34c.13 0 .25.05.35.14l1.35 1.3H2.5A2.45 2.45 0 0 0 0 4.77V8.6A2.45 2.45 0 0 0 2.5 11H7c1.28 0 2.36-.93 2.49-2.15l.91.65c.44.32 1.07.23 1.4-.2a.9.9 0 0 0 .2-.57V4.66c0-.36-.21-.7-.55-.86ZM8.5 8.6c0 .8-.67 1.44-1.5 1.44H2.5c-.83 0-1.5-.64-1.5-1.43V4.78c0-.79.67-1.43 1.5-1.43H7c.83 0 1.5.64 1.5 1.43v3.83Zm2.5.13L9.5 7.66V5.73L11 4.66v4.07Z" />
    </svg>
  )
}

const VideoConference = ({ className = '', style = {}, width = 7 }) => {
  return (
    <svg
      title="VideoConference"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 9"
      width={width}
    >
      <path fill="#6F6F6F" d="M.9 9a.9.9 0 0 1-.63-.25.79.79 0 0 1-.27-.6V.86C0 .61.09.41.27.24A.9.9 0 0 1 .9 0h7.8a.9.9 0 0 1 .63.25.8.8 0 0 1 .27.6v3.02L12 1.62v5.76L9.6 5.13v3.03a.8.8 0 0 1-.27.59.9.9 0 0 1-.63.25H.9Zm0-.84h7.8V.84H.9v7.32Z" />
    </svg>
  )
}

const Wifi = ({ className = '', style = {}, width = 7 }) => {
  return (
    <svg
      title="Wifi"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 13"
      width={width}
    >
      <path fill="#6F6F6F" d="M3.87 8.05 2.82 7a8.45 8.45 0 0 1 2.44-1.75A6.51 6.51 0 0 1 8 4.67c.98 0 1.9.2 2.74.58.85.39 1.67.97 2.44 1.75l-1.05 1.05a6.52 6.52 0 0 0-2.05-1.45 5.35 5.35 0 0 0-4.16 0 6.3 6.3 0 0 0-2.05 1.45ZM1.05 5.23 0 4.18a12.35 12.35 0 0 1 3.6-2.55A10.2 10.2 0 0 1 8 .67c1.56 0 3.02.32 4.4.96 1.36.65 2.57 1.5 3.6 2.55l-1.05 1.05A12.36 12.36 0 0 0 11.75 3 8.56 8.56 0 0 0 8 2.17 8.5 8.5 0 0 0 4.26 3a12.6 12.6 0 0 0-3.21 2.23ZM8 12.18l2.47-2.48A3.33 3.33 0 0 0 8 8.67 3.33 3.33 0 0 0 5.53 9.7L8 12.18Z" />
    </svg>
  )
}

const Monitor = ({ className = '', style = {}, width = 7 }) => {
  return (
    <svg
      title="Monitor"
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 12"
      width={width}
    >
      <path fill="#6F6F6F" d="M4.5 12v-1.33H1.33c-.26 0-.5-.1-.7-.3a.96.96 0 0 1-.3-.7V1c0-.27.1-.5.3-.7.2-.2.44-.3.7-.3h11.34c.26 0 .5.1.7.3.2.2.3.43.3.7v8.67c0 .26-.1.5-.3.7-.2.2-.44.3-.7.3H9.5V12h-5ZM1.33 9.67h11.34V1H1.33v8.67Z" />
    </svg>
  )
}



export {
  AirConditioner,
  Blackboard,
  Plug,
  Projector,
  VideoConference,
  Wifi,
  Monitor
}